<template>
  <div id="app">
    <AppTopBar v-if="isAuthenticated"></AppTopBar>
    <div v-if="isAuthenticated" class="top-logo"><b>mediafusion</b></div>

    <div v-if="isAuthenticated" class="layout-content">
      <router-view/>
    </div>
    <div v-if="!isAuthenticated" class="layout-signin">
      <router-view/>
    </div>
    <Toast/>
  </div>
</template>

<script>
import AppTopBar from "./layout/AppTopBar";
import UserService from "./services/user.service";
import {User} from "./models/user";
import {mapActions, mapGetters} from 'vuex';

export default {
  props: {keycloak: Object},
  name: "Login",
  components: {
    'AppTopBar': AppTopBar,
  },
  data() {
    return {
      currentUser: new User(),
      windowWidth: 500
    }
  },
  methods: {
    ...mapActions('nav', ['setWindowWidth']),
    ...mapActions('auth', ['setKeycloak']),
    getWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
      this.setWindowWidth(this.windowWidth);
    },
  },
  created() {
    UserService.currentUser.subscribe(data => {
      this.currentUser = data;
    })
  },
  computed: {
    ...mapGetters('nav', ['isSidebarVisible']),
    ...mapGetters('auth', [
      'isAuthenticated'
    ])
  },
  mounted() {
    if (this.keycloak !== null) {
      console.log("Keycloak available", this.keycloak);
      this.setKeycloak(this.keycloak);
    }

    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);

      //Init
      this.getWindowWidth()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  }
}
</script>

<style>
#app {
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
